var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.multiselect,{staticClass:"multiselect-mid",attrs:{"options":_setup.enterprises,"select-label":"","deselect-label":"","label":"name","track-by":"name"},model:{value:(_setup.enterprise),callback:function ($$v) {_setup.enterprise=$$v},expression:"enterprise"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }